import ECE1 from "../../../assets/images/ECE1.jpg";
import ECE2 from "../../../assets/images/ECE2.jpg";
import ECE3 from "../../../assets/images/ECE3.jpg";
// import img1 from '/public/images/IMG_9571-min.JPG';
import img1 from "../../../assets/images/IMG_9571-min.JPG";
import img2 from "../../../assets/images/IMG_9621-min.JPG";
import img3 from "../../../assets/images/IMG_9578-min.JPG";
import img4 from "../../../assets/images/IMG_9592-min.JPG";

export const Activities = [
  { id: 1, Avatar: img1 },
  { id: 2, Avatar: img2 },
  { id: 3, Avatar: img3 },
  { id: 4, Avatar: img4 },
  { id: 5, Avatar: ECE1 },
  { id: 6, Avatar: ECE2 },
  { id: 7, Avatar: ECE3 },
];
